import { OrderedMap } from 'immutable';
import { createSelector } from 'reselect';

import { ALERTS_REDUCER_KEY } from './alertsTypes';

export const getResourceStore = (state) => state[ALERTS_REDUCER_KEY];
export const getLoadPending = (state) => getResourceStore(state).loadPending;
export const getIsLoading = (state) => getResourceStore(state).isLoading;
export const getError = (state) => getResourceStore(state).error;
export const getLastSyncDate = (state) => getResourceStore(state).lastSyncDate;

export const getAlerts = createSelector(
  (state) => getResourceStore(state).resourcesById,
  (alerts) =>
    OrderedMap(alerts)
      .filter((alert) => {
        assert(alert, 'There should be no falsy items in the alert store.');

        return alert && !alert.isDismissed;
      })
      .sort((alert1, alert2) => alert2.createdAt?.localeCompare(alert1.createdAt)),
);

export const getAlertsUnread = createSelector(getAlerts, (alerts) => alerts.filter((alert) => !alert.isRead));
